import React, { useMemo } from 'react';
import { Collapse, Space, Typography } from 'antd';

import IntegrationEmailImage from 'static/images/integration-email-image.png';

import * as S from '../styles/intergrationEmail.style';
import { emailData } from '../utils/options';

const { Paragraph } = Typography;

const EmailParagraph = ({ title, lines }) => (
    <Paragraph>
        {title && (
            <>
                {title}
                <br />
            </>
        )}
        {lines.map((line, index) => (
            <React.Fragment key={index}>
                {line}
                <br />
            </React.Fragment>
        ))}
    </Paragraph>
);

export const IntegrationEmailExample = () => {
    const renderEmail = useMemo(
        () => (
            <Space direction='vertical'>
                <Paragraph>Статус: {emailData.status}</Paragraph>
                <EmailParagraph
                    title='Содержимое заказа:'
                    lines={emailData.orderContent}
                />
                <EmailParagraph title='Итого:' lines={emailData.totals} />
                <EmailParagraph
                    title='Адрес доставки:'
                    lines={emailData.deliveryAddress}
                />
                <Paragraph>Комментарий: {emailData.comment}</Paragraph>
                <S.Image preview={false} src={IntegrationEmailImage} />
            </Space>
        ),
        []
    );

    return (
        <Collapse
            size='middle'
            defaultActiveKey={1}
            items={[
                {
                    key: '1',
                    label: 'Пример письма',
                    children: renderEmail,
                },
            ]}
        />
    );
};
